import React from 'react';
import styled from 'styled-components';
import {
  IconSize,
  IconType,
  IconVariant,
  IconWrap,
  semanticTheme,
  Tooltip,
  Typography
} from '@tools/ui/dime';
import useT from '@tools/ui-hooks/useT';

type Props = {
  size?: IconSize;
  showLabel?: boolean;
};

const IconContainer = styled.span`
  margin-right: ${semanticTheme.dime.spacing.m};
`;

const LabelContainer = styled.span`
  display: flex;
  align-items: center;
  gap: ${semanticTheme.dime.spacing.m};
`;

export const PayrollIndicator: React.FC<Props> = ({
  size = IconSize.Medium,
  showLabel = false
}) => {
  const { t } = useT();
  const label = t('inbox.header.payroll');

  const icon = (
    <IconWrap
      type={IconType.Payroll}
      variant={IconVariant.Outline}
      size={size}
      style={{ color: semanticTheme.dime.colors.icon.primary }}
    />
  );

  if (showLabel) {
    return (
      <LabelContainer data-testid="payroll-indicator">
        {icon}
        <Typography variant="heading4">{label}</Typography>
      </LabelContainer>
    );
  }

  return (
    <Tooltip title={label}>
      <IconContainer data-testid="payroll-indicator" aria-label={label}>
        {icon}
      </IconContainer>
    </Tooltip>
  );
};
